﻿import { fetchAndBuildRoutes } from '@platform/app/router-functions';
import pages from '../pages';
import type { RouteRecordRaw } from 'vue-router';
import { loginRouteGen } from '@platform/layouts/login/login-routes';
import ManagingLoginCover from '@managing/components/ManagingLoginCover.vue';
import { toRaw } from 'vue';
import { NodeAPI } from '@platform/shared/rpc';
import { AuthRoutines } from '@platform/store';
import user_config from '@platform/components/user_config';

const defaultRoutes = (): RouteRecordRaw[] => [
    {
        name: 'SignedBaseLayout',
        path: '/',

        // @ts-ignore
        exact: true,
        component: () => import('@managing/layouts/mainapp.vue'),
        meta: {
            icon: 'home',
            label: 'Главная',
            menu: false,
            group: '',
            roles: null, //доступно всем
        },
        children: [
            {
                name: 'HomePage',
                path: '/',
                component: pages.home,
                alias: '/home',
                meta: {
                    icon: 'home',
                    label: 'Главная',
                    menu: true,
                    group: '',
                    roles: null, //доступно всем
                },
            },
        ],
    },
    loginRouteGen({
        coverComponent: ManagingLoginCover,
        withoutSupport: true,
        async authLoginCallback(loginData, { loginError }) {
            const { access_token, ...loginResult } = await NodeAPI.AuthService.loginV2(
                {
                    body: toRaw(loginData),
                    sysTemplateCode: 'managing',
                },
                { isAuthRequest: true } as any
            );
            const query_response = {
                id_token: 'fake-token_development-environment',
            };
            if (loginError) loginError.value = null;
            AuthRoutines.onLoad(query_response.id_token, access_token);
            loginResult.id_token = query_response.id_token;
            const orgInfo = await user_config.executeLoginRoutines(loginResult, loginData.login);
            user_config.guest.value = null;
        },
    }),
];

const route404 = {
    name: '404NotFound',
    path: '/:catchAll(.*)*',
    component: () => import('@pusk/pages/Error404.vue'),
    meta: {},
};
const DynamicTabRoute: RouteRecordRaw = {
    name: 'DynamicTab',
    path: '/forms/:tableName/:id/:params?',
    beforeEnter(to, from, next) {
        if (to.matched.length === 1) return next();
        const n = to.matched.find((r) => r.name !== 'DynamicTab');
        if (n) return next(n);
        next({ name: '404NotFound' });
    },
    component: pages.home,
    meta: {
        label: 'Загрузка...',
    },
};

export default async function () {
    const routes = await fetchAndBuildRoutes(switchComponent, defaultRoutes());
    if (routes[0]?.children) routes[0].children.push(DynamicTabRoute, route404);
    else routes.push(DynamicTabRoute, route404);
    return routes;
}

export function switchComponent(component: string) {
    return pages[component] ?? pages['/'];
}
